<div class="cg-multicolumn-list cg-multi-column-list-lg-2">
  <div class="cg-multicolumn-list__item">
    <ng-container *ngFor="let tin of changedTins">
      <h4
        class="cg-margin-top-none cg-margin-bottom-xs"
        data-test="lbl-changed-tin-name"
      >
        {{ tin.tin }}
        <ng-container *ngIf="tin.name !== '' && tin.name !== ' '"
          >({{ tin.name }})</ng-container
        >
      </h4>
      <ul class="cg-compare-list" data-test="lbl-affected-entitlements">
        <li
          *ngFor="let entitlementDiff of tin.diff.same"
          class="cg-compare-list__item--same"
          data-test="entitlement-same"
        >
          {{ entitlementDiff.name }}
          <ul class="cg-compare-list" *ngIf="entitlementDiff.updatedFunctions">
            <ng-container
              *ngIf="entitlementDiff.updatedFunctions?.same?.length"
            >
              <li
                *ngFor="let function of entitlementDiff.updatedFunctions?.same"
              >
                {{ function.name }}
              </li>
            </ng-container>
            <ng-container
              *ngIf="entitlementDiff.updatedFunctions?.added?.length"
            >
              <li
                class="cg-compare-list__item--added"
                *ngFor="let function of entitlementDiff.updatedFunctions?.added"
              >
                {{ function.name }}
              </li>
            </ng-container>
            <ng-container
              *ngIf="entitlementDiff.updatedFunctions?.removed?.length"
            >
              <li
                class="cg-compare-list__item--removed"
                *ngFor="
                  let function of entitlementDiff.updatedFunctions?.removed
                "
              >
                {{ function.name }}
              </li>
            </ng-container>
          </ul>
        </li>
        <li
          *ngFor="let entitlementDiff of tin.diff.added"
          [ngClass]="
            !isVendorSuccess && entitlementDiff.functions
              ? 'cg-compare-list__item--skipped'
              : 'cg-compare-list__item--added'
          "
          data-test="entitlement-added"
        >
          {{ entitlementDiff.name }}
          <ul class="cg-compare-list" *ngIf="entitlementDiff.functions?.length">
            <li *ngFor="let function of entitlementDiff.functions">
              {{ function.name }}
            </li>
          </ul>
        </li>
        <li
          *ngFor="let entitlementDiff of tin.diff.removed"
          [ngClass]="
            !isVendorSuccess && entitlementDiff.functions
              ? 'cg-compare-list__item--skipped'
              : 'cg-compare-list__item--removed'
          "
          data-test="entitlement-removed"
        >
          {{ entitlementDiff.name }}
          <ul class="cg-compare-list" *ngIf="entitlementDiff.functions">
            <li *ngFor="let function of entitlementDiff.functions">
              {{ function.name }}
            </li>
          </ul>
        </li>
      </ul>
    </ng-container>
  </div>
  <div class="cg-multicolumn-list__item" *ngIf="unChangedTins.length > 0">
    <h4
      class="cg-margin-top-none cg-margin-bottom-xs"
      data-test="lbl-unchanged-tin-header"
    >
      {{ userType === 'new' ? 'No Access Assigned' : 'No Changes' }}
    </h4>
    <ul class="cg-bullet-list" data-test="lbl-unchanged-tin-details">
      <li
        *ngFor="let tin of unChangedTins"
        class="cg-bullet-list__item cg-bullet-list__item--none"
        data-test="tin-no-change"
      >
        {{ tin.tin }}
        <ng-container *ngIf="tin.name !== '' && tin.name !== ' '"
          >({{ tin.name }})</ng-container
        >
      </li>
    </ul>
  </div>
</div>
